<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="containerCategoriesSelected"
    :clearable="!unclearable"
    :items="containerCategoriesItems"
    :loading="containerCategoriesLoading"
    :search-input.sync="containerCategoriesSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : '容器分类'"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import ContainerCategories from "@/api/container_categories";

export default {
  name: "SearcherContainerCategories",

  props: {
    value: Object,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
  },

  computed: {
    containerCategoriesItems() {
      return this.containerCategories.map((category) => {
        const Description = category.category_code + " / " + category.category_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == category.id
            )
          : false;
        return Object.assign({}, category, { Description, disabled });
      });
    },
  },

  data: () => ({    
    containerCategories: [],
    containerCategoriesLoading: false,
    containerCategoriesSearch: "",
    containerCategoriesSelected: null,
  }),

  methods: {
    getContainerCategoriesFromAPI() {
      this.containerCategoriesLoading = true;
      ContainerCategories.fetchAllForSelect()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.containerCategories = response.data.container_categories;
            }
            this.containerCategoriesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.containerCategoriesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.containerCategoriesSelected = this.value;
      },
    },
    containerCategoriesSelected: {
      handler() {
        this.$emit("input", this.containerCategoriesSelected);
      },
    },
    containerCategoriesSearch: {
      immediate: true, //初始赋值也调用
      handler() {
        if (
          this.containerCategoriesSelected &&
          this.containerCategoriesSearch ==
            this.containerCategoriesSelected.category_code + " / " + this.containerCategoriesSelected.category_name
        )
          return; // 查询结果一致的话不再执行

        this.getContainerCategoriesFromAPI();
      },
    },
  },
};
</script>
